import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError,of } from 'rxjs';
import {switchMap,  tap, catchError } from 'rxjs/operators';
import { UrlpathService } from './urlpath.service';

interface AuthResponse {
  message:string;
  data: {
    id:string;
    jwToken: string;
    email: string;
    roles: string;
    userName: string;
    message:string;
    refreshToken:string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly tokenKey = 'auth_token';
  private readonly idUser = 'idUser';
  private readonly idOwner = 'idOwner';
  private readonly userEmailKey = 'user_email';
  private readonly userRoleKey = 'user_role';
  private readonly userNameKey = 'user_name';
  private readonly refreshTokenA = 'refreshToken';

  private apiUrl = this.urlService.baseBackendUrlDev;
  httpOptions: { headers: HttpHeaders; } | any;

  constructor(
    private http: HttpClient,
    private urlService: UrlpathService
  ) {}

  isAuthenticated(): boolean {
    return !!localStorage.getItem(this.tokenKey);
  }

  private setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  private getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  private removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  setToken(token: string): void {
    this.setItem(this.tokenKey, token);
  }

  setId(id: string): void {
    this.setItem(this.idUser, id);
  }

  getUserRole(): string {
    return this.getItem(this.userRoleKey) || 'default';
  }

  setOwner(id: string): void {
    this.setItem(this.idOwner, id);
  }

  getToken(): string | null {
    return this.getItem(this.tokenKey);
  }

  clearToken(): void {
    this.removeItem(this.tokenKey);
  }

  login(credentials: { email: string; password: string }): Observable<AuthResponse> {
    const url = `${this.apiUrl}Account/authenticate`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Accept: 'application/json' });

    return this.http.post<AuthResponse>(url, credentials, { headers }).pipe(
      tap((response) => {
        if (response.data.jwToken) {
           
          this.setToken(response.data.jwToken);
          this.setItem(this.userEmailKey, response.data.email);
          this.setItem(this.refreshTokenA, response.data.refreshToken);

          this.setItem(this.userRoleKey, response.data.roles);
          this.setItem(this.userNameKey, response.data.userName);
        } 
      }),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  

  forgotPassword(credentials: { email: string }): Observable<any> {
    const url = `${this.apiUrl}Account/forgot-password`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Accept: 'application/json' });

    return this.http.post(url, credentials, { headers }).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  logoutApp(email: string): Observable<any> {
    const url = `${this.apiUrl}Account/logout?userEmail=${email}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Accept: 'application/json' });

    return this.http.get(url, { headers }).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  resetPassword(credentials: { email: string; token: string; password: string; confirmPassword: string }): Observable<any> {
    const url = `${this.apiUrl}Account/reset-password`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Accept: 'application/json' });

    return this.http.post(url, credentials, { headers }).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }


  //Products
  productUpload(data: string): Observable<any> {
    const url = `${this.apiUrl}Product/batch`;
    
    const token = localStorage.getItem('auth_token');
    if (!token) {
      return throwError(() => new Error('Token not found'));
    }
      
    this.httpOptions = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    
    return this.http.post(url, data, { headers: this.httpOptions }).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }


  productGetReport(dateIn: any, dateEnd: any): Observable<any> {
    const url = `${this.apiUrl}Product/bydaterange`;
  
    const token = localStorage.getItem('auth_token');
    if (!token) {
      return throwError(() => new Error('Token not found'));
    }
  
    const httpOptions = {
      headers: new HttpHeaders({ 'Authorization': `Bearer ${token}` })
    };
  
    return this.http.get(`${url}?from=${dateIn}&to=${dateEnd}`, httpOptions).pipe(
      catchError((error) => throwError(() => error))
    );
  }

  isTokenExpired(): boolean {
    const token = localStorage.getItem('token'); // O de donde tengas guardado el token
    if (!token) return true;

    const payload = JSON.parse(atob(token.split('.')[1]));
    const expirationDate = payload.exp * 1000; // Convertir la fecha a milisegundos
    return expirationDate < Date.now();
  }

   // Función para refrescar el token
  refreshToken(): Observable<any> {
    const refreshToken = localStorage.getItem('refreshToken'); // Aquí deberías obtener el refresh token
    const userEmail = localStorage.getItem('user_email');
    const url = `${this.apiUrl}Account/refreshtoken`;

    return this.http.post<any>(url, { token: refreshToken, email: userEmail }).pipe(
      switchMap((response:any) => {
        if (response && response.jwToken) {
          // Guardar el nuevo token
          localStorage.setItem('refreshToken', response.refreshToken);
          return of(response.refreshToken);
        }
        throw new Error('No se pudo renovar el token');
      }),
      catchError((error) => {
        return of(null);
      })
    );
  }



  

  logout(): void {
    localStorage.clear();
  }
}
